/*
 * @Author: your name
 * @Date: 2020-07-20 09:35:47
 * @LastEditTime: 2020-07-20 10:28:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kxzxweb\src\common\sdkxjtSec\index.js
 */
import React from 'react'
import { SectionWrap } from './style'
import { NavLink } from 'react-router-dom'

class NewSection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      swArr: [],
    }
  }
  render() {
    return (
      <SectionWrap key={this.props.secarr.id} className="hdbd_section">
        <div className="icon">
          <svg
            t="1595209339009"
            className="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2796"
            width="32"
            height="32"
          >
            <path
              d="M215.801653 76.165289H117.362248C54.737455 76.165289 4.231405 125.427306 4.231405 186.071802v728.021686C4.231405 974.737983 54.745917 1024 117.362248 1024h789.275504c62.624793 0 113.130843-49.262017 113.130843-109.906512V186.071802C1019.768595 125.427306 969.254083 76.165289 906.637752 76.165289H808.198347V35.264529C808.198347 15.78314 789.250116 0 765.884298 0s-42.31405 15.78314-42.31405 35.264529V76.165289H300.429752V35.264529C300.429752 15.78314 281.481521 0 258.115702 0s-42.31405 15.78314-42.314049 35.264529V76.165289z m84.628099 101.553719h423.140496v40.900761C723.570248 238.101157 742.518479 253.884298 765.884298 253.884298s42.31405-15.78314 42.314049-35.264529V177.719008h97.153058c16.392463 0 29.789091 12.685752 29.789091 28.621223v704.410447c0 15.935471-13.396628 28.621223-29.789091 28.621223H118.648595c-16.392463 0-29.789091-12.685752-29.789091-28.621223V206.340231C88.859504 190.413223 102.256132 177.719008 118.648595 177.719008H215.801653v40.900761C215.801653 238.101157 234.749884 253.884298 258.115702 253.884298s42.31405-15.78314 42.31405-35.264529V177.719008zM173.487603 778.66314A33.902017 33.902017 0 0 1 207.338843 744.727273h101.553719a33.85124 33.85124 0 0 1 33.85124 33.935867v16.756364A33.902017 33.902017 0 0 1 308.892562 829.355372H207.338843a33.85124 33.85124 0 0 1-33.85124-33.935868v-16.756364z m0-186.181818A33.902017 33.902017 0 0 1 207.338843 558.545455h101.553719a33.85124 33.85124 0 0 1 33.85124 33.935867v16.756364A33.902017 33.902017 0 0 1 308.892562 643.173554H207.338843a33.85124 33.85124 0 0 1-33.85124-33.935868v-16.756364z m253.884298 0A33.902017 33.902017 0 0 1 461.22314 558.545455h101.55372a33.85124 33.85124 0 0 1 33.851239 33.935867v16.756364A33.902017 33.902017 0 0 1 562.77686 643.173554H461.22314a33.85124 33.85124 0 0 1-33.851239-33.935868v-16.756364z m253.884297 0A33.902017 33.902017 0 0 1 715.107438 558.545455h101.553719a33.85124 33.85124 0 0 1 33.85124 33.935867v16.756364A33.902017 33.902017 0 0 1 816.661157 643.173554H715.107438a33.85124 33.85124 0 0 1-33.85124-33.935868v-16.756364z m-507.768595-186.181818A33.902017 33.902017 0 0 1 207.338843 372.363636h101.553719a33.85124 33.85124 0 0 1 33.85124 33.935868v16.756364A33.902017 33.902017 0 0 1 308.892562 456.991736H207.338843a33.85124 33.85124 0 0 1-33.85124-33.935868v-16.756364z m253.884298 0A33.902017 33.902017 0 0 1 461.22314 372.363636h101.55372a33.85124 33.85124 0 0 1 33.851239 33.935868v16.756364A33.902017 33.902017 0 0 1 562.77686 456.991736H461.22314a33.85124 33.85124 0 0 1-33.851239-33.935868v-16.756364z m253.884297 0A33.902017 33.902017 0 0 1 715.107438 372.363636h101.553719a33.85124 33.85124 0 0 1 33.85124 33.935868v16.756364A33.902017 33.902017 0 0 1 816.661157 456.991736H715.107438a33.85124 33.85124 0 0 1-33.85124-33.935868v-16.756364z"
              fill="#22a9c7"
              p-id="2797"
            ></path>
          </svg>
        </div>
        <div className="hdbd_section_detail">
          <NavLink
            className="hdbd_section_detail_title"
            to={'/article/' + this.props.secarr.id}
          >
            {
              parseInt(this.props.secarr.istop, 10) > 0 ?
                <span className='zd'>
                  <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/home/zda.png`} alt="" />
                </span> :
                ""
            }
            {this.props.secarr.post_title}
          </NavLink>
          <div className="hdbd_section_date">
            {this.props.secarr.post_excerpt}
          </div>
        </div>
      </SectionWrap>
    )
  }
}
export default NewSection
